import React from 'react'
import Script from 'next/script'

// The GA4 + Meta pixel pair that most public pages paste inline at the bottom.
// New pages use this instead of another copy. Script ids match the inline
// copies, so next/script loads each tag only once per session.
export const PageAnalytics = () => (
    <>
        <Script
            id="google-tagmanager-new"
            src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
            strategy="lazyOnload"
            onLoad={() => {
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', 'G-QD1HGGHDYJ');
            }}
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
            {`!function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '128634041116395');
              fbq('track', 'PageView');`}
        </Script>
    </>
)
